import { render } from "./ProcureModal.vue?vue&type=template&id=7f7797f4&scoped=true"
import script from "./ProcureModal.vue?vue&type=script&lang=js"
export * from "./ProcureModal.vue?vue&type=script&lang=js"

import "./ProcureModal.vue?vue&type=style&index=0&id=7f7797f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7797f4"]])

export default __exports__